export const Radio = {
  parts: ['label'],
  baseStyle: {
    label: {
      fontWeight: 'bold',
    },
  },
};
